import * as React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import './styles.scss';

interface CDropdownProps {
  title?: string;
  items: Array<string>;
  onSelect: (eventKey: any) => void;
}
class CustomDropdown extends React.Component<CDropdownProps> {
  state = {
    title: null
  };

  onSelectHandler = eventKey => {
    this.setState({
      title: this.props.items[eventKey]
    });
    this.props.onSelect(this.props.items[eventKey]);
  };

  render() {
    const { title, items } = this.props;
    return (
      <DropdownButton
        className="custom-dropdown"
        id="main-header-dropdown"
        variant="light"
        title={title || this.state.title || items[0]}
      >
        {items.map((val, id) => (
          <Dropdown.Item
            key={`item-${id}`}
            eventKey={id.toString()}
            className="dropdown-item"
            onSelect={this.onSelectHandler}
          >
            {val}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    );
  }
}

export default CustomDropdown;
